import _ from 'lodash';
import {setSelectedItems} from '../tree/actions';


export const SET_DATA = 'BOOK_SET_DATA';

export function setData(data, elementId) {
    return dispatch => dispatch([
        setSelectedItems(
            data.grade ? [data.grade.id] : [],
            'grade',
            elementId + ':gradeTree',
        ),
        setSelectedItems(
            data.category ? [data.category.id] : [],
            'book-category',
            elementId + ':categoryTree',
        ),
        setSelectedItems(
            _.map(data.compilers, item => item.id),
            'compiler',
            elementId + ':compilersTree',
        ),
        setSelectedItems(
            _.map(data.coworkers, item => item.id),
            'compiler',
            elementId + ':coworkersTree',
        ),
        setSelectedItems(
            _.map(data.editors, item => item.id),
            'compiler',
            elementId + ':editorsTree',
        ),
        setSelectedItems(
            data.print_type ? [data.print_type] : [],
            'print-type',
            elementId + ':printTypeTree',
        ),
    ]);
}
